import ProgressContainer from './progress_container';

const Progress = ProgressContainer;
export default Progress;
